import { FC, useContext, useEffect, useLayoutEffect, useReducer, useRef, useState } from "react";
// import PracticeContactInfo from "src/components/practiceContactInfo";
import HighchartsReact from 'highcharts-react-official'
import { format, subYears } from 'date-fns';
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ReactPaginate from "react-paginate";

import AuthSubHeader from "src/components/authSubHeader";
import FooterText from "src/components/footerText";
import CaseTableFilters from "src/components/caseListingFilters";
import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import CancelTreatment from "src/components/modals/cancelTreatment";
import RenderNextStep from "./caseItemActions";
import ReRunPatientModal from "src/components/modals/rerunPatientModal";
import TransferCaseModal from "src/components/modals/transferCaseDialogs/transferCaseModal";
import TransferNotNowModal from "src/components/modals/transferCaseDialogs/transferNotNowModal";
import UploadClinicalModal from "src/components/modals/transferCaseDialogs/uploadClinicalModal";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { BAR_CHART } from "../../constants/highCharts";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
import { LoaderContext } from "src/context/loaderContext";

import { CaseListAPIResponseType, CaseListingType, QueryParamsState, QueryStateActionType, QueryStateActions } from "./types";
import { CASE_HEADER_LISTING, CASE_STATUS_LISTING } from "src/constants/cases";
import { initialState, queryParamReducer } from "./reducer";
import { AuthContext } from "src/context/authContext";
import { handleNavigation } from "src/helpers";
import AddNote from "src/components/modals/addNote";
import { PracticeDropdownResponse } from "src/components/caseStepTwo/types";
import PracticeContactInfo from "src/components/practiceContactInfo";
import TableHeader from "src/components/tableHeader";




const Dashboard: FC = (): JSX.Element => {

  const [chartOptions, setChartOptions] = useState(BAR_CHART);
  const [pageSearch, setPageSearch] = useState("");

  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number; title: string; bentype: string; investigated_at?: string }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    title: '',
    bentype: "",
    investigated_at: ""
  });
  const [showReRunPatientModal, setShowReRunPatientModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number, title: string, bentype: string; investigated_at?: string; }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    title: '',
    bentype: ""
  });
  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [transferCaseModal, setTransferCaseModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })
  const [transferCaseNotnowModal, setTransferCaseNotnowModal] = useState<boolean>(false)
  const [precertInfoModal, setPrecertInfoModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })
 const [saveNoteModal, setDataforNoteModal] = useState<{ isModalVisible: boolean; caseId: number; }>({
    isModalVisible: false,
    caseId: 0,
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, updateSearchParams] = useSearchParams();
  
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { defaultView } = useContext(AuthContext);
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useContext(AuthContext);

  const [queryParams, dispatch] = useReducer(
    queryParamReducer, 
    initialState({
      date_from: searchParams.get("date_from") || format(subYears(new Date(), 1), "yyyy-MM-dd") || "",
      date_to: searchParams.get("date_to") || format(new Date(), "yyyy-MM-dd") || "",
      page: Number(searchParams.get('page')) || 1,
      direction: (searchParams.get("direction") as "desc" | "asc") || "desc",
      sort_by: searchParams.get("sort_by") || "id",
      global_doctor_id: searchParams.get('global_doctor_id') || "",
      practice_id: searchParams.get("practice_id") || "",
      search_query: searchParams.get("search_query") || "",
      open: searchParams.get("open") || ""
    })
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps,
  useLayoutEffect(() => setLoader(), [])

  /**
   * @getPracticeDropdown api to get practice based listing
   * @first initialize the useFetch() hook
   * @second trigger practice listing api to get listing
   */
  const {data: practiceDropdownApiRes } = 
    useFetch<PracticeDropdownResponse>(APIEndpoints.PRACTICE_DROPDOWN);




  const { data: caseObject, mutate: getCaseListing, error: caseError, removeErrorAndData: clearCaseState } =
    useFetch<CaseListAPIResponseType, QueryParamsState>(APIEndpoints.CASE_LIST, { ...queryParams, date_from: "", date_to: "" }, {}, false);



  useEffect(() => {
    if (["Contact", "Practice"].includes(userData?.ref_type || "")) {
      if (practiceDropdownApiRes) {
        const practiceId = practiceDropdownApiRes.data?.[0]?.id.toString();
        getCaseListing({}, {}, { ...queryParams, start_date: "", end_date: "", practice_id: practiceId });
      }
    } else if (["Organization"].includes(userData?.ref_type || "")) {
      getCaseListing({}, {}, { ...queryParams, start_date: "", end_date: "" });
    } else if (["GlobalDoctor"].includes(userData?.ref_type || "")) {
      getCaseListing({}, {}, { ...queryParams, start_date: "", end_date: "", global_doctor_id: userData?.ref_id?.toString() ?? "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceDropdownApiRes]);

  useEffect(() => {
    if (caseObject?.status || caseError) {
      hideLoader();
      if (caseObject?.status) {
        if (caseObject.status === 500) {
          showToast(['No cases found against provided filters'], ToastTypes.ERROR);
        }
        showToast(['Cases data fetched successfully'], ToastTypes.SUCCESS);
        const latestChartOptions = { ...chartOptions };
        latestChartOptions.series = [{
          type: 'bar',
          name: 'Value',
          data: [caseObject.pending, caseObject.investigated],
        }];

        setChartOptions(latestChartOptions);
        const chart = chartComponentRef.current?.chart;

        if (chart) {
          chart.redraw();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseObject, caseError]);

  const onClearButtonClicked = (updatedState: QueryParamsState) => {
    if (caseError || caseObject) clearCaseState();
    dispatch({
      type: QueryStateActions.CLEAR_STATE,
      payload: updatedState
    });
    // dispatch({
    //   type: QueryStateActions.SET_FILTERS,
    //   payload: {
    //     global_doctor_id:
    //       userData?.ref_type === "GlobalDoctor"
    //         ? userData.id?.toString()
    //         : "",

    //     practice_id:
    //       userData?.ref_type === "Practice" ||
    //         userData?.ref_type === "Contact"
    //         ? userData.ref_id?.toString()
    //         : "",
    //   },
    // });
    const params = new URLSearchParams({ ...updatedState, global_doctor_id: userData?.ref_type === "GlobalDoctor" ? userData.id?.toString() : "",practice_id: (userData?.ref_type === "Practice" || userData?.ref_type === "Contact") ? practiceDropdownApiRes?.data?.[0]?.id.toString() ?? "" : "" } as unknown as Record<string, string>);
    updateSearchParams(params.toString(), { replace: false });
    getCaseListing(null, null, updatedState);
  };

  const handleSearchWithQueryParam = (updatedState?: QueryParamsState) => {
    if (caseError || caseObject) clearCaseState();
    setLoader();
    const updatedParams = { ...queryParams  };
    updatedParams.date_from = updatedState?.date_from || queryParams.date_from;
    updatedParams.date_to = updatedState?.date_to || queryParams.date_to;
    updatedParams.search_query = updatedState?.search_query || queryParams.search_query;
    updatedParams.practice_id = updatedState?.practice_id || queryParams.practice_id;
    updatedParams.open = updatedState?.open || queryParams.open;
    updatedParams.sort_by = updatedState?.sort_by || queryParams.sort_by;
    updatedParams.direction = updatedState?.direction || queryParams.direction;
    updatedParams.page = updatedState?.page || queryParams.page;
    
    // const { ...cleanedQueries } = updatedParams;
    const params = new URLSearchParams(updatedParams as unknown as Record<string, string>);
    updateSearchParams(params.toString(), { replace: false });
    dispatch({
      type: QueryStateActions.CHANGE_QUERY_PARAMS,
      payload: updatedParams,
    })
    // dispatch({
    //   type: QueryStateActions.CHANGE_FROM_DATE,
    //   payload: updatedParams.date_from,
    // })
    // dispatch({
    //   type: QueryStateActions.CHANGE_TO_DATE,
    //   payload: updatedParams.date_to,
    // })
    // dispatch({
    //   type: QueryStateActions.CHANGE_CASE_STATUS,
    //   payload: updatedParams.open,
    // })
    // dispatch({
    //   type: QueryStateActions.CHANGE_PRACTICE_ID,
    //   payload: updatedParams.practice_id,
    // })
    // dispatch({
    //   type: QueryStateActions.CHANGE_SEARCH_QUERY,
    //   payload: updatedParams.search_query,
    // })
    getCaseListing(null, null, updatedParams ? updatedParams : queryParams);
  };





  const getDateFormat = (dateAndTime: string) => {
    if (dateAndTime)
      return format(new Date(dateAndTime), "MM/dd/yyyy")
  };

  const changeIdOrder = (value: string) => {
    const order = queryParams.direction === 'desc' ? 'asc' : 'desc';

    const action: QueryStateActionType = {
      type: QueryStateActions.CHANGE_SORT_PARAMS,
      payload: {
        direction: order,
        sort_by: value,
      },
    };
    dispatch(action);

    const updatedState = queryParamReducer(queryParams, action);
    handleSearchWithQueryParam(updatedState);
  };

  const changePageNumber = (page: { selected: number; }) => {
    const action: QueryStateActionType = {
      type: QueryStateActions.CHANGE_PAGE,
      payload: page.selected + 1,
    };
    dispatch(action);

    const updatedState = queryParamReducer(queryParams, action);
    handleSearchWithQueryParam(updatedState);
  };

  const navigateToModalAndPage = (item: CaseListingType) => {
    if (item.re_run_type === 'popup') {
      setShowReRunPatientModal({ caseId: item.id, isModalVisible: true, prescriptionId: item.prescription_id, title: "Please update case status below", bentype: "med", investigated_at: item.investigated_at ?? undefined })
    } else {
      navigate(`/cases/${item?.id}/clone`)
    }
  }


  const handlePageSearch = () => {
    const pageNumber = Number(pageSearch);

    if (caseObject) {
      if (!pageNumber || pageNumber < 1 || pageNumber > caseObject.total_pages) {
        return;
      }

    }
    const action: QueryStateActionType = {
      type: QueryStateActions.CHANGE_PAGE,
      payload: pageNumber,
    };

    dispatch(action);

    const updatedState = queryParamReducer(queryParams, action);
    handleSearchWithQueryParam(updatedState);  // API call

    setPageSearch("");
  };

  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      navigate(0)
    }
  }

  useEffect(() => {
    if (queryParams) {
      const params = new URLSearchParams(queryParams as unknown as Record<string, string>);
      updateSearchParams(params.toString(), { replace: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams])

  // useEffect(() => {
  //       const updatedParams = {
  //         ...queryParams,
  //         date_from: searchParams.get('date_from') ?? (format(subYears(new Date(), 1), "yyyy-MM-dd") || ""),
  //         date_to: searchParams.get('date_to') ?? (format(new Date(), "yyyy-MM-dd") || ""),
  //         period: searchParams.get('period') || "day",
  //         case_id: searchParams.get('case_id') || "",
  //         global_patient_id: searchParams.get('global_patient_id') || "",
  //         global_doctor_id:userData?.ref_type === "GlobalDoctor" ? userData.id?.toString() : searchParams.get('global_doctor_id') || "",
  //         practice_id: ["Practice", "Contact"].includes(userData?.ref_type || "")
  //           ? practiceDropdownApiRes?.data?.[0]?.id.toString() ?? "" : searchParams.get('practice_id') || "",
  //         global_patient_external_id: searchParams.get('global_patient_external_id') || "",
  //         ref_user: searchParams.get('ref_user') || "",
  //         search_query: searchParams.get('search_query') || "",
          
          
  //               //ref_user: (searchParams.get('role') || getRole() || userData?.ref_type) !== "Manufacturer" ? (searchParams.get('id') || userData?.id?.toString() || "") : "",
  //         //filter: searchParams.get('filter') || "",
  //         //filter_type: searchParams.get('filter_type') || "",
  //         // type: "index",
  //         // role: "manufacturer",
  //         // id: searchParams.get('id') || "",
  //       };
  //       // if (!dashboardLoading) {
  //         dispatch({
  //           type: QueryStateActions.CHANGE_QUERY_PARAMS,
  //           payload: updatedParams,
  //         })
  //       // }
  //       // eslint-disable-next-line react-hooks/exhaustive-deps
  //     }, [searchParams]);

  return (
    <div className="container-fluid overflow-y-auto overflow-x-auto d-flex flex-column flex-fill">
      <AuthSubHeader />

      <div className="card my-4 mt-0">
        <div className="card-header">
          <h3 className="text-white mb-0 fs-4">Active and Recently Completed Cases</h3>
        </div>

        <div className="card-body p-0">
          <div className="px-3 py-3 light-primary-bg">
            <p>The following is a list of all active and completed cases. Click on the Case ID to view details of the case. Yellow cases require user attention.</p>

            <CaseTableFilters
              dropdownData={CASE_STATUS_LISTING}
              inputPlaceholder="Search by Case ID, Patient, Physician"
              state={queryParams}
              dispatch={dispatch}
              handleSearchWithQueryParam={handleSearchWithQueryParam}
              onClearButtonClicked={onClearButtonClicked}
              practiceDropdown={practiceDropdownApiRes?.data || []}
            />
          </div>

          <div className="table-responsive">
            <table className="table table-striped table-sm">
              <thead>
                <tr className="text-center">
                  {CASE_HEADER_LISTING.map((tableHeader, index) => (
                    <TableHeader
                      key={index} tableHeader={{ ...tableHeader, width: "" }} 
                      sortConfig={{ direction: queryParams.direction, sort_by: queryParams.sort_by }}
                      changeIdOrder={changeIdOrder}
                    />
                  ))}
                </tr>
              </thead>

              <tbody>
                {caseObject && caseObject.cases && caseObject.cases.length > 0 ?
                  caseObject.cases.map((item, index) => {
                  const isOffice = item.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "office"
                  const isFam = item.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "fam"
                    return (
                    <tr key={item.id} className="text-center">
                      <td className="align-middle">
                        <Link
                          to={{ pathname: `/cases/${item.id}` }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          title={`Patient ID: ${item.patient ? item.patient.external_id : ''}`}
                          className="btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover fs-6 user-select-text"
                        >
                          {item.id}
                        </Link>
                      </td>
                      {/* <td className="fs-6">{item ? item.ongoing : ''}</td> */}
                      <td className="align-middle">
                        {typeof item.ongoing === "string" && item.ongoing ? (
                          <button type="button" className={`btn btn-sm ${item.ongoing.toLowerCase() === "new" ? "btn-success" : "btn-green"} user-select-text`}>
                            {item.ongoing}
                          </button>
                        ) : null}</td>
                      <td className="align-middle">{item ? getDateFormat(item.created_at) : ''}</td>
                      <td className="align-middle">{item ? getDateFormat(item.investigated_at) : ''}</td>

                      <td className="align-middle">{item ? item.treated : ''}</td>
                      <td className="align-middle">{item ? item.next_eligible_tmnt : ''}</td>

                      <td className="align-middle">
                        <Link
                          to={`/global_patients/${item.patient.global_patient_id}/edit`}
                          className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                        >
                          {item.patient.firstlastname}
                        </Link>
                      </td>
                      <td className="align-middle">
                        <PracticeContactInfo 
                          indexKey={index} 
                          name={item.practice_name}
                          address={item.practice_full_address}
                          phone={item.practice_phone_number ?? ""}
                          fax={item.practice_fax_number ?? ""}
                        >
                          <>{item && item.doctor ? item.doctor.firstlastname : ''}</>
                        </PracticeContactInfo>
                      </td>
                      <td className={`text-white align-middle background-color-${item && item.color_idx ? item.color_idx : 1}`}>
                        {item ? item.status_name : ''}
                      </td>

                      <td className="align-middle" id="medical_provide_treatment_status">
                        <RenderNextStep
                          setDataForCancelModal={setDataForCancelModal}
                          showHideModalForTreatment={setDataForRequestModalTreatment}
                          updateVisibilityOfTransferModal={setTransferCaseModal}
                          updateClinicalDocumentModal={setTransferCaseModal}
                          case_id={item.id}
                          prescription_id={item.prescription_id}
                          investigated_at={item.investigated_at || ""}
                          active_precert_id={item.active_precert_id}
                          appeal_precert_id={item.appeal_precert_id}
                          pending_precert_id={item.pending_precert_id}
                          next_Steps={item.next_step}
                          action_Required={false}
                          pa_workflow_required={item.pa_workflow_required}
                          refreshListing={() => getCaseListing(null, null, queryParams)}
                        />
                      </td>

                      <td style={{ minWidth: '115px' }} className="align-middle">
                        <button type="button" className="btn btn-green btn-sm my-2 rounded-0" onClick={() => navigateToModalAndPage(item)}>
                          <i className="fas fa-sync-alt"></i> Re-run
                        </button>
                      </td>
                      <td className="align-middle text-center fs-6" style={{ minWidth: '105px' }}>
                        {item?.kam_fam_notes?.clickable && item?.kam_fam_notes.text ? (
                          item?.kam_fam_notes.text === 'Add Note' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: item.id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {item?.kam_fam_notes.text}
                            </button>
                          ) : item.kam_fam_notes.text === 'Confirm Indication' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: item.id })
                              }
                            >
                              <i className="fas fa-times me-1"></i> Add Note
                            </button>
                          ) : 
                           !(String(item?.kam_fam_notes?.text ?? "").includes("No FAM Action Needed")) ? (
                            (<button
                              className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: item.id })
                              }
                            >
                              {item?.kam_fam_notes.text}
                            </button>)
                          ) : (<button
                            type="button"
                            className="btn btn-green btn-sm rounded-0"
                            onClick={() =>
                              setDataforNoteModal({ isModalVisible: true, caseId: item.id })
                            }
                          >
                            <i className="fas fa-times me-1"></i> Add Note
                          </button>)
                        ) : (
                         <button
                            type="button"
                            className="btn btn-green btn-sm rounded-0"
                            onClick={() =>
                              setDataforNoteModal({ isModalVisible: true, caseId: item.id })
                            }
                          >
                            <i className="fas fa-times me-1"></i> Add Note
                          </button>
                        )}
                      </td>
                    </tr>
                  )
                }) : null}
              </tbody>
            </table>
          </div>
          {caseObject && caseObject.total_pages && caseObject.total_pages > 1 ? (
            <div className="pagination pagination-sm pagination-lg justify-content-center flex-wrap gap-2">
              {queryParams.page !== 1 ? (
                <li className="page-item">
                  <button className="btn btn-link page-link rounded-0"
                    onClick={() => changePageNumber({ selected: 0 })}>
                    <i className="bi bi-chevron-double-left"></i> First
                  </button>
                </li>
              ) : null}

              <ReactPaginate
                nextLabel={<>Next <i className="bi bi-chevron-right"></i></>}
                onPageChange={changePageNumber}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={caseObject.total_pages}
                previousLabel={<><i className="bi bi-chevron-left"></i> Previous</>}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link rounded-0"
                nextClassName="page-item"
                nextLinkClassName="page-link rounded-0"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination pagination-sm pagination-lg"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={queryParams.page - 1}
              />

              {queryParams.page !== caseObject.total_pages ? (
                <li className={`page-item ${queryParams.page === caseObject.total_pages ? 'disabled' : ''}`}>
                  <button className="btn btn-link page-link rounded-0"
                    onClick={() => changePageNumber({ selected: caseObject.total_pages - 1 })}>
                    Last <i className="bi bi-chevron-double-right"></i>
                  </button>
                </li>
              ) : null}
              <li className="page-item">
                <input
                  type="number"
                  min={1}
                  max={caseObject.total_pages}
                  className="form-control page-link"
                  style={{ width: "67px" }}
                  placeholder="Page"
                  value={pageSearch}
                  onChange={(e) => setPageSearch(e.target.value)}
                  onBlur={handlePageSearch}          // 👈 Fire on focus out
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.currentTarget.blur();        // 👈 Trigger blur = auto jump
                    }
                  }}
                />
              </li>
            </div>
          ) : null}
        </div>
      </div>

      <FooterText />

      {showRequestTreatmentModal.isModalVisible && (
        <RequestDateOfTreatment
          isModalVisible={showRequestTreatmentModal.isModalVisible}
          caseId={showRequestTreatmentModal.caseId}
          prescriptionId={showRequestTreatmentModal.prescriptionId}
          title={showRequestTreatmentModal.title}
          investigated_at={showRequestTreatmentModal.investigated_at}
          hideModal={() => {
            setDataForRequestModalTreatment({
              isModalVisible: false,
              caseId: 0,
              prescriptionId: 0,
              title: "",
              bentype: "",
              investigated_at: ""
            });
          }}
          refreshListing={() => redirectDecision()}
          bentype={showRequestTreatmentModal.bentype}
        />
      )}
      <AddNote
        isModalVisible={saveNoteModal.isModalVisible}
        caseId={saveNoteModal.caseId}
        refreshListing={() => redirectDecision()}
        hideModal={() => {
          setDataforNoteModal({
            isModalVisible: false,
            caseId: 0,
          });
        }}
      />

      <CancelTreatment
        isModalVisible={cancelTreatmentModal.isModalVisible}
        caseId={cancelTreatmentModal.caseId}
        prescriptionId={cancelTreatmentModal.prescriptionId}
        hideModal={() => {
          setDataForCancelModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
      <ReRunPatientModal
        isModalVisible={showReRunPatientModal.isModalVisible}
        caseId={showReRunPatientModal.caseId}
        prescriptionId={showReRunPatientModal.prescriptionId}
        bentype={showReRunPatientModal.bentype}
        title={showReRunPatientModal.title}
        investigated_at={showReRunPatientModal.investigated_at}
        hideModal={() => {
          setShowReRunPatientModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0,
            bentype: '',
            title: "",
            investigated_at: undefined
          });
        }}
        refreshListing={() => redirectDecision()}
      />

      <TransferCaseModal
        isModalVisible={transferCaseModal.isModalVisible}
        hideModal={() => {
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
          setTransferCaseNotnowModal(true)
        }}
        uploadClinicalInfo={() => {
          setPrecertInfoModal({
            isModalVisible: true,
            caseId: transferCaseModal.caseId,
            precertId: transferCaseModal.precertId,
          })
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
        }}
      />

      <TransferNotNowModal
        isModalVisible={transferCaseNotnowModal}
        hideModal={() => setTransferCaseNotnowModal(false)}
      />

      <UploadClinicalModal
        caseId={precertInfoModal.caseId}
        precertId={precertInfoModal.precertId}
        isModalVisible={precertInfoModal.isModalVisible}
        hideModal={(shouldFetchAgain: boolean) => {
          if (shouldFetchAgain) {
            redirectDecision();
          }
          setPrecertInfoModal({
            isModalVisible: false,
            caseId: 0,
            precertId: 0,
          })
        }}
      />
    </div>
  );
};

export default Dashboard;
